import { createAnatomy as p } from "../../anatomy/dist/index.mjs";
import { createScope as i, queryAll as I } from "../../dom-query/dist/index.mjs";
var u = p("pinInput").parts("root", "label", "input", "control");
u.build();
var n = i({
  getRootId: (t) => {
    var e;
    return ((e = t.ids) == null ? void 0 : e.root) ?? `pin-input:${t.id}`;
  },
  getInputId: (t, e) => {
    var d, o;
    return ((o = (d = t.ids) == null ? void 0 : d.input) == null ? void 0 : o.call(d, e)) ?? `pin-input:${t.id}:${e}`;
  },
  getHiddenInputId: (t) => {
    var e;
    return ((e = t.ids) == null ? void 0 : e.hiddenInput) ?? `pin-input:${t.id}:hidden`;
  },
  getLabelId: (t) => {
    var e;
    return ((e = t.ids) == null ? void 0 : e.label) ?? `pin-input:${t.id}:label`;
  },
  getControlId: (t) => {
    var e;
    return ((e = t.ids) == null ? void 0 : e.control) ?? `pin-input:${t.id}:control`;
  },
  getRootEl: (t) => n.getById(t, n.getRootId(t)),
  getInputEls: (t) => {
    const d = `input[data-ownedby=${CSS.escape(n.getRootId(t))}]`;
    return I(n.getRootEl(t), d);
  },
  getInputEl: (t, e) => n.getById(t, n.getInputId(t, e)),
  getFocusedInputEl: (t) => n.getInputEls(t)[t.focusedIndex],
  getFirstInputEl: (t) => n.getInputEls(t)[0],
  getHiddenInputEl: (t) => n.getById(t, n.getHiddenInputId(t))
});
export {
  u as anatomy
};
